import { React, useEffect, useState, useRef } from "react";
import { Link, useNavigate, } from "react-router-dom";
import Banner from "../Components/Banner";
import Property from "../Components/Property";
import AOS from 'aos';
import FAQ from '../Components/FAQ/FAQ';
import Button from "../Components/Button"
import phone from '../images/phone.png'
import chat_icon from '../images/message.png'
import email_icon from '../images/email.png'
import whatspp from '../images/whatsapp.png'
import blog1 from '../images/primary/blogs/blog-1.webp'
import blog2 from '../images/primary/blogs/blog-2.webp'
import blog3 from '../images/primary/blogs/blog-3.webp'
import blog4 from '../images/primary/blogs/blog-4.webp'
import blog5 from '../images/primary/blogs/blog-5.webp'
import blog6 from '../images/primary/blogs/blog-6.webp'
import blog7 from '../images/primary/blogs/blog-7.webp'
// import blog8 from '../images/primary/blogs/blog-8.webp'
import FormModal from '../Components/FormModal';

import residential_banner from '../images/banner_images/laptop/residental.png'
import mresidential_image from '../images/banner_images/mobile/mobile_residentialbanner.png'
import property_image from '../images/prop_image.png'
import vector from '../images/prop_vector.svg'
import zero from '../images/residential/zero.png'
import FeaturedServices from "../Components/FeaturedServices";
import Chatwithus from "../Components/chatwithus";
import apartments_icon from "../images/primary/apartments_icon.png"
import sale_icon from "../images/primary/sale_icon.png"
import resale_icon from "../images/primary/resale_icon.png"
import rental_icon from "../images/primary/rental_icon.png"
import google_logo from '../images/liaison/Google-Review-Logo 1.png'
import TestimonialSlider from "../Components/testimonial_slider";
import ChatusForm from "../Components/ChatusForm";




function Primary() {

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, [])

    const [modalToggle, setModalToggle] = useState(false);

    function toggle() {
        setModalToggle(!modalToggle);
    }


    // const articles = [
    //     {
    //         image: blog1,
    //         heading: "India Land Tech Park launches Phase 3 of its IT Park in Coimbatore",
    //         link: "https://www.aninews.in/news/business/business/indialand-tech-park-launches-phase-3-of-its-it-park-in-coimbatore-to-meet-rising-demand20230315160650/"
    //     },
    //     {
    //         image: blog2,
    //         heading: "2,000cr sanctioned to modernise airports",
    //         link: "https://timesofindia.indiatimes.com/city/coimbatore/2000cr-sanctioned-to-modernise-airport/articleshow/96072647.cms"
    //     },
    //     {
    //         image: blog3,
    //         heading: "Coimbatore to get tow industrial parks..",
    //         link: "https://www.thehindu.com/news/cities/Coimbatore/coimbatore-to-get-two-industrial-parks-for-the-defence-sector/article66866725.ece"
    //     },
    //     {
    //         image: blog4,
    //         heading: "Wester Ring Road makes Kovaipudur..",
    //         link: "https://timesofindia.indiatimes.com/business/india-business/western-ring-road-makes-kovaipudur-coimbatores-next-big-real-estate-investment/articleshow/96603372.cms?from=mdr",
    //     },
    //     {
    //         image: blog5,
    //         heading: "Coimbatore Ranked Top Smart Cities...",
    //         link: "https://bwsmartcities.businessworld.in/article/Coimbatore-Ranked-Amongst-Top-Smart-Cities-In-India-/25-05-2023-477966/",
    //     },
    //     {
    //         image: blog6,
    //         heading: "Coimbatore metro rail: Avinashi & Sathy roads to be covered...",
    //         link: "https://timesofindia.indiatimes.com/city/coimbatore/coimbatore-metro-rail-avinashi-and-sathy-roads-to-be-covered-in-first-phase/articleshow/101416252.cms"
    //     },
    //     {
    //         image: blog7,
    //         heading: "First phase of Semmozhi Poonga works to start on 45 acres",
    //         link: "https://www.thehindu.com/news/cities/Coimbatore/first-phase-of-semmozhi-poonga-works-to-start-in-45-acres-of-prison-land-in-coimbatore/article66507386.ece"
    //     },
    //     {
    //         image: blog2,
    //         heading: "Union government has sanctioned 2,000 crore for modernising",
    //         link: "https://timesofindia.indiatimes.com/city/coimbatore/2000cr-sanctioned-to-modernise-airport/articleshow/96072647.cms",
    //     },
    // ]


    return (
        <>
            {/* Banner Image */}

            <Banner
                img={residential_banner}
                mimg={mresidential_image}
                heading="Unlisted properties for you, exclusively."
                subheading="Homes, Apartments & Villas"
                textposition={'w-[85%] left-7 bottom-12 lg:w-[560px] lg:bottom-16 lg:left-20 '}
                renderButton={() => (
                    <Button name={"Explore Properties"} design={"filled"} action={"scroll"} section_id={"property-section"} />
                )}

            />
            {/* Bottom bar */}
            {/* <div className="font-alibaba text-font-grey fixed bottom-4 left-1/2 -translate-x-1/2 bg-white rounded-lg flex items-center gap-x-14 py-4 px-7 border-[0.50px] border-[#BABABA] shadow-2xl !z-10">

                <a href="tel:+91 9025134134" target="_blank">
                    <div className="flex items-center gap-x-2 group hover:underline">
                        <img className="w-[18px] h-[20px] opacity-50 group-hover:opacity-100" src={phone} alt="icons " />
                        <p className="text-[16px]">Call</p>
                    </div>
                </a>

                <a href="https://wa.me/+919025134134" target="_blank">
                    <div className="flex items-center gap-x-2 group hover:underline">
                        <img className="w-[18px] h-[20px] opacity-50 group-hover:opacity-100" src={whatspp} alt="icons " />
                        <p className="text-[16px]">Whatsapp</p>
                    </div>
                </a>

                <div className="flex items-center gap-x-2 group cursor-pointer hover:underline" onClick={toggle}>
                    <img className="w-[20px] h-[18px] opacity-50 group-hover:opacity-100" src={email_icon} alt="icons " />
                    <p className="text-[16px]">Enquire</p>
                </div>

            </div> */}

            {/* Service Description */}
            <div className="max-w-7xl mx-auto my-20 z-0">
                <div className='max-w-[770px] mx-auto my-20'>
                    <h1 className='heading' data-aos="fade-up">One Stop Destination </h1>
                    <hr className='border-yellow border-[2px] w-[87px] mx-auto my-5' data-aos="fade-up" data-aos-duration="800" />
                    <p className="service-description max-w-[722px] mx-auto" data-aos="fade-up" data-aos-duration="1100">Explore your dream property from our exclusively curated Apartments,  Villas & Plots from CREDAI certified A-Grade Developers. Save you  time & energy with our one stop shop.</p>
                </div>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-x-12 sm:flex-wrap gap-y-12 ">
                    <div className=" flex flex-col items-center bg-white px-[30px] pt-[40px] pb-[55px] shadow-xl w-[294px] h-[533px] gap-y-9 relative" data-aos="fade-up" data-aos-duration="800">
                        <img src={apartments_icon} alt="apartment_icon" className="w-[74px] h-[73px]" />

                        <h1 className="font-noto text-hblack text-[26px] font-bold leading-[40px] text-center text-wrap ">Apartments & Villas</h1>
                        <p className="font-alibaba text-[18px] text-font-grey font-normal leading-[26px] text-center ">Check new houses for sale in Coimbatore at Lands and Lands. Buy Luxury apartments and flats hassle-free.</p>

                        <div className="absolute w-fit bottom-10">
                            <Button
                                name={"Explore Now"}
                                design={"unfilled"}
                                action={"internal-linking"}
                                pageLink={"/apartments-and-villas-for-sale-in-coimbatore"}
                            />
                        </div>

                    </div>

                    <div className=" flex flex-col items-center bg-white px-[30px] pt-[40px] pb-[55px] shadow-xl w-[294px] h-[533px] gap-y-9 relative" data-aos="fade-up" data-aos-duration="1200">
                        <img src={sale_icon} alt="apartment_icon" className="w-[74px] h-[73px]" />

                        <h1 className="font-noto text-hblack text-[26px] font-bold leading-[40px] text-center text-wrap ">Sale Plots & Residences</h1>
                        <p className="font-alibaba text-[18px] text-font-grey font-normal leading-[26px] text-center w-[250px]">Lands and Lands offers low budget land for sale in Coimbatore.</p>

                        <div className="absolute w-fit bottom-10">
                            <Button
                                name={"Explore Now"}
                                design={"unfilled"}
                                action={"internal-linking"}
                                pageLink={"/plots-for-sale-in-coimbatore"}
                            />
                        </div>

                    </div>

                    <div className=" flex flex-col items-center bg-white px-[30px] pt-[40px] pb-[55px] shadow-xl w-[294px] h-[533px] gap-y-9 relative" data-aos="fade-up" data-aos-duration="1600">
                        <img src={apartments_icon} alt="apartment_icon" className="w-[74px] h-[73px]" />

                        <h1 className="font-noto text-hblack text-[26px] font-bold leading-[40px] text-center text-wrap ">Resale<br />Houses & Villas</h1>
                        <p className="font-alibaba text-[18px] text-font-grey font-normal leading-[26px] text-center w-[250px]">Resale Houses and Villas for sale around Coimbatore.</p>

                        <div className="absolute w-fit bottom-10">
                            <Button
                                name={"Explore Now"}
                                design={"unfilled"}
                                action={"internal-linking"}
                                pageLink={"/buy-house-in-coimbatore"}
                            />
                        </div>

                    </div>


                    {/* <div className=" flex flex-col items-center bg-white px-[30px] pt-[40px] pb-[55px] shadow-xl w-[294px] h-[533px] gap-y-9 relative">
                        <img src={apartments_icon} alt="apartment_icon" className="w-[74px] h-[73px]" />

                        <h1 className="font-noto text-hblack text-[26px] font-bold leading-[40px] text-center text-wrap ">Rent <br /> Office Space</h1>
                        <p className="font-alibaba text-[18px] text-font-grey font-normal leading-[26px] text-center w-[250px]">Get office space for rent in Coimbatore. Lease office space for rent, fast and hassle-free.</p>

                        <div className = "absolute w-fit bottom-10"> 
                            <Button
                            name = {"Explore Now"}
                            design = {"unfilled"}
                            action = {"internal-linking"}
                            pageLink = {"/residential/apartments-and-villas-for-sale-in-coimbatore"}
                        />
                        </div>

                    </div> */}
                </div>


            </div>


            <Property list="apartment" />

            <TestimonialSlider />

            <a href='https://www.google.com/search?sca_esv=0cc3b5bc5eb43f9c&si=AMgyJEvkVjFQtirYNBhM3ZJIRTaSJ6PxY6y1_6WZHGInbzDnMQrBjsHIRqCxxwTbPxUbJ4RMTn-S7H5ZS_OlrXE3HjAzhGXUfdnaJrezLduvGnb69kqo76JZmUEA-jPkDJw4eW3a1_LH&q=Lands+and+Lands+Reviews&sa=X&ved=2ahUKEwin4ZCY1LmPAxU6R2cHHVIaIpUQ0bkNegQIJhAE&biw=1504&bih=860&dpr=2' target="_blank">
                <div className='flex-col justify-center text-center'>
                    <img className='w-[168px] mx-auto' src={google_logo} alt='Google_logo' data-aos="fade-up" />
                    <p className='text-[18px] text-[#575857] mt-[10px]' data-aos="fade-up">Check out our Google reviews page <span className='text-[#FF0000]'> here.</span></p>
                </div>
            </a>

            <Chatwithus />

            {/* <ChatusForm /> */}
            <FormModal
                modal={modalToggle}
                active={toggle}
            />


        </>
    )
}

export default Primary;
